import { render } from "./TenantNativeCallConfigsManagement.vue?vue&type=template&id=014060b2"
import script from "./TenantNativeCallConfigsManagement.vue?vue&type=script&lang=js"
export * from "./TenantNativeCallConfigsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__